import { UserTRoundCheckIcon } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
import WsTeamFilter from './WsTeamsFilter';

const TeamFilter = ({
  name,
  title,
  defaultValue,
  defaultObjects,
  showAccordionIcon,
  onSelectMultipleValues,
}: WsFilterProps) => (
  <WsAccordion
    title={title ?? 'Posted By Teams'}
    startIcon={showAccordionIcon ? <UserTRoundCheckIcon /> : null}
  >
    <WsTeamFilter
      name={name}
      defaultValue={defaultValue}
      defaultObjects={defaultObjects}
      onSelectMultipleValues={onSelectMultipleValues}
    />
  </WsAccordion>
);

export default TeamFilter;
